"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/src/components/shadcn/ui/card";
import { ReferralMatchEvidence } from "@/src/components/tasks/approval-types/referral-match-evidence";
import { ApprovalType, type TaskApproval } from "@/src/models/task-approval";

function EvidenceContent({ approval }: { approval: TaskApproval }) {
  switch (approval.approvalType) {
    case ApprovalType.REFERRAL_MATCH:
      return <ReferralMatchEvidence metadata={approval.metadata} />;
  }
}

export function ApprovalEvidenceCard({ approval }: { approval: TaskApproval }) {
  return (
    <Card className="bg-warn/5 border border-warn/20">
      <CardHeader>
        <CardTitle className="text-center">Action Pending Review</CardTitle>
      </CardHeader>
      <CardContent>
        <EvidenceContent approval={approval} />
      </CardContent>
    </Card>
  );
}
